import { IStaticThemeColors } from '../interfaces/IStaticThemeColors';
import { IDynamicThemeColors } from '../interfaces/IDynamicThemeColors';

export const dynamicColors: IDynamicThemeColors = {
  neutral: {
    '1000': '#000000',
    '950': '#0E121B',
    '900': '#181B25',
    '800': '#222530',
    '700': '#2B303B',
    '600': '#525866',
    '500': '#717784',
    '400': '#99A0AE',
    '300': '#CACFD8',
    '200': '#E1E4EA',
    '100': '#F2F5F8',
    '50': '#F5F7FA',
    '0': '#FFFFFF',
  },
};

export const staticColors: IStaticThemeColors = {
  transparent: '#00000000',
  grey: {
    '1000': '#000000',
    '950': '#0E121B',
    '900': '#181B25',
    '800': '#222530',
    '700': '#2B303B',
    '600': '#525866',
    '500': '#717784',
    '400': '#99A0AE',
    '300': '#CACFD8',
    '200': '#E1E4EA',
    '100': '#F2F5F8',
    '50': '#F5F7FA',
    '0': '#FFFFFF',
  },
  green: {
    '950': '#0B4627',
    '900': '#16643B',
    '800': '#1A7544',
    '700': '#178C4E',
    '600': '#1DAF61',
    '500': '#1FC16B',
    '400': '#3EE089',
    '300': '#84EBB4',
    '200': '#C2F5DA',
    '100': '#D0FBE9',
    '50': '#E0FAEC',
  },
  blue: {
    '950': '#122368',
    '900': '#182f8b',
    '800': '#1f3bad',
    '700': '#2547d0',
    '600': '#3559e9',
    '500': '#335cff',
    '400': '#6895ff',
    '300': '#97baff',
    '200': '#c0d5ff',
    '100': '#d5e2ff',
    '50': '#ebf1ff',
  },
  orange: {
    '950': '#682f12',
    '900': '#8b3e18',
    '800': '#ad4e1f',
    '700': '#d05e25',
    '600': '#e97135',
    '500': '#ff8447',
    '400': '#ff9a68',
    '300': '#ffba97',
    '200': '#ffd5c0',
    '100': '#ffe3d5',
    '50': '#fff1eb',
  },
  red: {
    '950': '#681219',
    '900': '#8b1822',
    '800': '#ad1f2b',
    '700': '#d02533',
    '600': '#e93544',
    '500': '#fb3748',
    '400': '#ff6875',
    '300': '#ff97a0',
    '200': '#ffc0c5',
    '100': '#ffd5d8',
    '50': '#ffebec',
  },
  yellow: {
    '950': '#624c18',
    '900': '#86661d',
    '800': '#a78025',
    '700': '#c99a2c',
    '600': '#e6a819',
    '500': '#f6b51e',
    '400': '#ffd268',
    '300': '#ffe097',
    '200': '#ffecc0',
    '100': '#ffefcc',
    '50': '#fffaeb',
  },
  purple: {
    '950': '#351a75',
    '900': '#3d1d86',
    '800': '#4c25a7',
    '700': '#5b2cc9',
    '600': '#693ee0',
    '500': '#7d52f4',
    '400': '#8c71f6',
    '300': '#a897ff',
    '200': '#cac0ff',
    '100': '#dcd5ff',
    '50': '#efebff',
  },
  sky: {
    '950': '#124b68',
    '900': '#18658b',
    '800': '#1f7ead',
    '700': '#2597d0',
    '600': '#35ade9',
    '500': '#47c2ff',
    '400': '#68cdff',
    '300': '#97dcff',
    '200': '#c0eaff',
    '100': '#d5f1ff',
    '50': '#ebf8ff',
  },
  teal: {
    '950': '#0b463e',
    '900': '#16645a',
    '800': '#1a7569',
    '700': '#178c7d',
    '600': '#1daf9c',
    '500': '#22d3bb',
    '400': '#3fdec9',
    '300': '#84ebdd',
    '200': '#c2f5ee',
    '100': '#d0fbf5',
    '50': '#e4fbf8',
  },
  pink: {
    '950': '#68123d',
    '900': '#8b1852',
    '800': '#ad1f66',
    '700': '#d0257a',
    '600': '#e9358f',
    '500': '#fb4ba3',
    '400': '#ff68b3',
    '300': '#ff97cb',
    '200': '#ffc0df',
    '100': '#ffd5ea',
    '50': '#ffebf4',
  },
  alphaBlue: {
    '24': '#476CFF3D',
    '16': '#476CFF29',
    '10': '',
  },
  alphaGrey: {
    '24': '#99A0AE3D',
    '16': '#99A0AE29',
    '10': '',
  },
  alphaOrange: {
    '24': '#FF91473D',
    '16': '#FF914729',
    '10': '',
  },
  alphaYellow: {
    '24': '#FBC64B3D',
    '16': '#FBC64B29',
    '10': '',
  },
  alphaRed: {
    '24': '#FB37483D',
    '16': '#FB374829',
    '10': '',
  },
  alphaGreen: {
    '24': '',
    '16': '#1FC16B29',
    '10': '#1FC16B1A',
  },
  alphaPurple: {
    '24': '#784DEF3D',
    '16': '#784DEF29',
    '10': '',
  },
  alphaSky: {
    '24': '#47C2FF3D',
    '16': '#47C2FF29',
    '10': '',
  },
  alphaPink: {
    '24': '#FB4BA33D',
    '16': '#FB4BA329',
    '10': '',
  },
  alphaTeal: {
    '24': '#22D3BB3D',
    '16': '#22D3BB29',
    '10': '',
  },
};
